import { useState } from "react";
import DoctorAdminForm from "./DoctorAdminForm";
import Axios from "axios";
import Nav3 from './Nav3';

function CreateDoctorAdmin() {
    const [arr, setArr] = useState([]);
    const getState = (childData) => {
        setArr(childData);
    }

    const handleSubmit = () => {
        const data = { name: arr[0], email: arr[1], contact: arr[2], specialization: arr[3] }
        Axios.post("https://hms-backend2.onrender.com/doctoradminRoute/create-doctoradmin", data)
            .then((res) => {
                if (res.status === 200)
                    alert("Record added successfully")
                else
                    Promise.reject();
            })
            .catch((err) => alert(err));
    }
    return (
        <div><Nav3/>
            <form onSubmit={handleSubmit}>
                <DoctorAdminForm getState={getState} nameValue="" emailValue="" contactValue="" specializationValue="">Add Doctor</DoctorAdminForm>
            </form>
        </div>
    )
}
export default CreateDoctorAdmin;